<template>
    <v-layout justify-center>
        <v-responsive width="100%" height="100%" class="mx-n3 px-3">
            <list-heading v-model="showsSearch" title="사용자 목록" showsFilterButton />

            <v-expand-transition>
                <v-card v-show="showsSearch" outlined class="mx-auto">
                    <v-card-title class="subtitle-2 font-weight-bold">검색필터</v-card-title>
                    <v-card-text class="pb-0">
                        <v-row align="center">
                            <v-col cols="12" :md="isTypeIndividual ? '' : '3'">
                                <v-select v-model="filter.type" :items="userTypes" label="유형" v-bind="selectAttrs" />
                            </v-col>
                            <v-col cols="12" :md="isTypeIndividual ? '' : '3'" v-if="isTypeIndividual">
                                <v-select v-model="filter.kind" :items="userKinds" label="유형상세" v-bind="selectAttrs" />
                            </v-col>
                            <v-col cols="12" md="3">
                                <v-text-field v-model="filter.name" label="사용자명(일반회원)" @keydown.enter="search" v-bind="attrs_input" />
                            </v-col>
                            <v-col cols="12" md="3">
                                <v-text-field v-model="filter.companyName" label="기업명(기업회원)" @keydown.enter="search" v-bind="attrs_input" />
                            </v-col>
                            <v-col cols="12" md="3">
                                <v-text-field v-model="filter.phone" label="연락처" @keydown.enter="search" v-bind="attrs_input" />
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" rounded text @click="search"> <v-icon small class="mt-1 mr-2">mdi-magnify</v-icon>검색 </v-btn>
                    </v-card-actions>
                </v-card>
            </v-expand-transition>

            <!-- <div class="primary--text caption mt-8">★★ 바이어 / 셀러 DB 등록 시 양식을 다운로드 받아서 DB를 작성해주세요</div>
        <div class="primary--text caption mt-1">★★ 바이어 / 셀러 등록 전 반드시 중복 체크를 먼저 진행해 주세요!</div> -->
            <v-row>
                <!-- <v-col cols="auto">
                <v-btn color="white" class="pink--text px-2 ml-1" @click="$refs.buyerInput.$el.getElementsByTagName('input')[0].click()">
                    <v-file-input accept=".xlsx" ref="buyerInput" class="d-none" @change="file => upload(file, 'buyer')"/>
                    <v-icon class="mr-2">{{ mdiMicrosoftExcel }}</v-icon>바이어 업로드
                </v-btn>
                <v-btn color="white" class="green--text px-2 ml-1" @click="download('/assets/excel/buyer-example.xlsx')">
                    <v-icon class="mr-2">{{ mdiMicrosoftExcel }}</v-icon>바이어 양식 다운로드
                </v-btn>
                <v-btn color="white" class="pink--text px-2 ml-1" @click="$refs.sellerInput.$el.getElementsByTagName('input')[0].click()">
                    <v-file-input accept=".xlsx" ref="sellerInput" class="d-none" @change="file => upload(file, 'seller')" />
                    <v-icon class="mr-2">{{ mdiMicrosoftExcel }}</v-icon>셀러 업로드
                </v-btn>
                <v-btn color="white" class="green--text px-2 ml-1" @click="download('/assets/excel/seller-example.xlsx')">
                    <v-icon class="mr-2">{{ mdiMicrosoftExcel }}</v-icon>셀러 양식 다운로드
                </v-btn>
            </v-col> -->
                <v-spacer></v-spacer>
                <v-col cols="auto">
                    <v-btn v-show="false" color="white" class="green--text px-2 ml-1" @click="excel">
                        <v-icon class="mr-2">{{ mdiMicrosoftExcel }}</v-icon
                        >엑셀다운로드
                    </v-btn>
                </v-col>
            </v-row>
            <v-data-table v-model="selected" v-bind="{ headers, items }" disable-sort disable-pagination hide-default-footer class="v-sheet--outlined">
                <template #[`item.name`]="{ item }">
                    {{ item.name || item.workerName || "-" }}
                </template>
                <template #[`item.createdAt`]="{ item }">
                    <span v-if="item.createdAt">{{ item.createdAt.toDateTime() }}</span>
                    <span v-else>-</span>
                </template>
                <template #[`item.companyName`]="{ item }">
                    <span v-if="item.companyName">{{ item.companyName }}</span>
                    <span v-else-if="item.affiliation">{{ item.affiliation }}</span>
                    <span v-else>-</span>
                </template>
                <template #[`item.phone`]="{ item }">
                    <span v-if="item.phone">{{ item.phone.phoneNumberFormat() }}</span>
                    <span v-else>-</span>
                </template>
                <template #[`item.email`]="{ item }">
                    <span v-if="item.email">{{ item.email }}</span>
                    <span v-else>-</span>
                </template>
                <template #[`item.isApproval`]="{ item }">
                    <v-row justify="center" align="center" v-if="isSupporter(item)">
                        <v-col cols="auto" class="pa-0">
                            <v-switch v-model="item.isApproval" @change="updateUser({ _id: item._id, isApproval: item.isApproval })" v-bind="attrs_switch" />
                        </v-col>
                    </v-row>
                </template>
                <template #[`item.isExpert`]="{ item }">
                    <v-row justify="center" align="center" v-if="isOrganization(item) || isSupporter(item)">
                        <v-col cols="auto" class="pa-0">
                            <v-switch v-model="item.isExpert" @change="updateUser({ _id: item._id, isExpert: item.isExpert })" v-bind="attrs_switch" />
                        </v-col>
                    </v-row>
                </template>
                <template #[`item.isDisplayed`]="{ item }">
                    <v-row justify="center" align="center" v-if="isOrganization(item) || isSupporter(item)">
                        <v-col cols="auto" class="pa-0">
                            <v-switch v-model="item.isDisplayed" @change="updateUser({ _id: item._id, isDisplayed: item.isDisplayed })" v-bind="attrs_switch" />
                        </v-col>
                    </v-row>
                </template>
                <template #[`item.isContactDisplayed`]="{ item }">
                    <v-row justify="center" align="center" v-if="isOrganization(item) || isSupporter(item)">
                        <v-col cols="auto" class="pa-0">
                            <v-switch v-model="item.isContactDisplayed" @change="updateUser({ _id: item._id, isContactDisplayed: item.isContactDisplayed })" v-bind="attrs_switch" />
                        </v-col>
                    </v-row>
                </template>
                <template #[`item.scope.editor`]="{ item }">
                    <v-row justify="center" align="center">
                        <v-col cols="auto" class="pa-0">
                            <user-list-item-scope-switch v-model="item.scope" scopeValue="editor" @change="updateUser({ _id: item._id, scope: item.scope })" v-bind="attrs_switch" />
                        </v-col>
                    </v-row>
                </template>
                <template #[`item.orderPrice`]="{ item }">
                    <span v-if="item.orderPrice">{{ item.orderPrice.format() }}</span>
                    <span v-else>-</span>
                </template>
                <template #[`item.actions`]="{ item }">
                    <v-icon small @click="edit(item)"> mdi-pencil </v-icon>
                    <v-icon small @click="remove(item)" class="ml-2"> mdi-delete </v-icon>
                </template>
            </v-data-table>
            <!-- <v-row>
                <v-spacer />
                <v-col cols="auto" class="caption primary--text">* 주의회원 체크시 문자와 메일이 발숭되지 않으니 주의 부탁드립니다</v-col>
            </v-row> -->
            <v-pagination v-model="page" :length="pageCount" :total-visible="11" class="mt-4 mx-4" @input="search()"></v-pagination>

            <!-- <v-tabs v-model="tabIndex" background-color="transparent">
                <v-tab>문자발송</v-tab>
                <v-tab>메일발송</v-tab>
            </v-tabs>

            <v-tabs-items v-model="tabIndex" class="mb-6">
                <v-tab-item :key="0">
                    <message-post-card v-model="selected" :summary="summary" v-bind="filter"></message-post-card>
                </v-tab-item>
                <v-tab-item :key="1">
                    <email-post-card v-model="selected" :summary="summary" v-bind="filter"></email-post-card>
                </v-tab-item>
            </v-tabs-items> -->

            <!-- <v-btn color="pink" fab fixed right bottom dark @click="create">
                <v-icon>mdi-pencil</v-icon>
            </v-btn> -->

            <!-- <user-uploader ref="uploader" @save="search"></user-uploader> -->

            <user-add-dialog @input="pushItem" />
        </v-responsive>
    </v-layout>
</template>

<script>
import api from "@/api";
import XLSX from "xlsx";
import download from "downloadjs";
import { mdiMicrosoftExcel } from "@mdi/js";
import { INDIVIDUAL_KINDS, initDataTableHeaders, USER_TYPES } from "@/assets/variables";

import ListHeading from "@/components/console/dumb/list-heading.vue";
import UserUploader from "@/components/console/user/user-uploader.vue";
import EmailPostCard from "@/components/console/user/email-post-card.vue";
import UserAddDialog from "@/components/console/user/user-add-dialog.vue";
import MessagePostCard from "@/components/console/user/message-post-card.vue";
import UserListItemScopeSwitch from "@/components/console/user/user-list-item-scope-switch.vue";

const commonAttrs = { outlined: true, persistentPlaceholder: true, "hide-details": true };
const attrs_input = { ...commonAttrs, dense: true, clearable: true };
const selectAttrs = { ...commonAttrs, dense: true };
const attrs_switch = { ...commonAttrs, inset: true, class: "my-0 py-0 ml-4" };
const userKinds = [{ text: "전체", value: null }, ...Object.keys(INDIVIDUAL_KINDS).map((value) => ({ text: INDIVIDUAL_KINDS[value], value }))];

const headers = initDataTableHeaders(
    [
        { width: 100, text: "사용자(담당자)\r\n이름", value: "name" },
        { text: "기업/소속/학교", value: "companyName" },
        { width: 120, text: "아이디", value: "username" },
        { width: 110, text: "연락처(담당자)", value: "phone" },
        { width: 200, text: "이메일(담당자)", value: "email" },
        { width: 170, text: "유형", value: "title" },
        { width: 100, text: "가입일자", value: "createdAt" },
        { width: +80, text: "가입\r\n승인", align: "center", value: "isApproval" },
        { width: +80, text: "전문기업/\r\n전문가 승인", align: "center", value: "isExpert" },
        { width: +80, text: "검색\r\n노출", align: "center", value: "isDisplayed" },
        { width: +80, text: "연락처\r\n노출", align: "center", value: "isContactDisplayed" },
        { width: +80, text: "에디터\r\n권한", align: "center", value: "scope.editor" },
        {
            width: +80,
            text: "",
            value: "actions",
            align: "center",
        },
    ],
    {
        className: "px-2 white-space-pre-line",
        cellClass: "px-2 caption line-height-1-5 white-space-pre-line",
    }
);

export default {
    components: {
        ListHeading,
        UserUploader,
        EmailPostCard,
        UserAddDialog,
        MessagePostCard,
        UserListItemScopeSwitch,
    },
    data() {
        return {
            mdiMicrosoftExcel, // 엑셀아이콘

            showsSearch: true,

            filter: {
                name: this.$route.query.name || null,
                companyName: this.$route.query.companyName || null,
                phone: this.$route.query.phone || null,
                type: this.$route.query.type || null,
                kind: this.$route.query.kind || null,
            },

            page: +this.$route.query.page || 1,
            pageCount: 0,
            limit: 10,

            tabIndex: 0,
            messageType: "email",
            messageTypes: [
                { text: "이메일 발송", value: "email" },
                { text: "SMS 발송", value: "sms" },
            ],
            messageTarget: "selected",
            messageSubject: "",
            message: null,

            selected: [],
            users: [],
            summary: { totalCount: 0 },

            headers,

            levels: [],

            isWarningsItems: [
                { text: "전체", value: null },
                { text: "주의회원", value: true },
                { text: "미주의회원", value: false },
            ],

            attrs_input,
            selectAttrs,
            attrs_switch,

            userTypes: [
                { text: "전체", value: null },
                { text: "일반회원", value: USER_TYPES.INDIVIDUAL },
                { text: "기업회원", value: USER_TYPES.ORGANIZATION },
            ],
            userKinds,
        };
    },
    computed: {
        items() {
            return [...(this.users || [])];
        },
        isTypeIndividual() {
            return this.filter.type == USER_TYPES.INDIVIDUAL;
        },
    },
    methods: {
        download,

        async init() {
            try {
                var { levels } = await api.console.levels.gets();
                this.levels = levels;

                this.search();
            } catch (error) {
                console.error(error);
            }
        },
        async search() {
            try {
                this.$router.push({
                    query: Object.assignDefined({}, this.$route.query, this.filter, {
                        page: this.page,
                    }),
                });

                var { summary, users } = await api.console.users.gets({
                    headers: {
                        skip: (this.page - 1) * this.limit,
                        limit: this.limit,
                    },
                    params: this.filter,
                });

                this.users = users;
                this.summary = summary;
                this.pageCount = Math.ceil(summary.totalCount / this.limit);
            } catch (error) {
                console.error(error);
                if (error.response) alert(error.response.data.email);
                else alert(error.email.toString());
            }
        },

        create() {
            this.$router.push(`/console/users/create`);
        },

        edit(user) {
            this.$router.push({
                path: `/console/users/${user._id}`,
            });
        },

        async updateUser(user) {
            try {
                await api.console.users.put(user);
            } catch (error) {
                console.error(error);
                alert(error.response ? error.response.data.email : error.email);
            }
        },

        async remove(user) {
            const go = confirm(`사용자 (ID: ${user?.username})를 삭제하시겠습니까?`);
            if (go) {
                try {
                    [{ user }] = [await api.console.users.delete(user)];

                    this.users = this.users.filter(({ _id }) => _id !== user._id);
                    alert(`사용자 (ID: ${user?.username})가 삭제되었습니다.`);
                } catch (error) {
                    console.error(error);
                    alert(error.response ? error.response.data.email : error.email);
                }
            }
        },

        async excel() {
            try {
                var { users } = await api.console.users.gets({
                    headers: {
                        limit: 0,
                    },
                    params: this.filter,
                });

                var rows = [];
                users.forEach((user) => {
                    rows.push({
                        아이디: user?.username,
                        서브비밀번호: user?.subPassword,
                        "사용자 이름": user?.name,
                        연락처: user?.phone,
                        이메일: user?.email,
                        회원등급: user?.level?.name,
                        주의회원여부: user?.isWarning ? "주의" : "-",
                        가입일자: user?.createdAt?.toDateTime(),
                    });
                });

                var workbook = new XLSX.utils.book_new();
                var worksheet = XLSX.utils.json_to_sheet(rows);

                XLSX.utils.book_append_sheet(workbook, worksheet, "new");
                XLSX.writeFile(workbook, "회원목록.xlsx");
            } catch (error) {
                console.error(error);
                alert(error.response ? error.response.data.email : error.email);
            }
        },

        async sendemail() {
            try {
                var users;
                switch (this.messageTarget) {
                    case "search": {
                        users = (
                            await api.console.users.gets({
                                params: this.filter,
                            })
                        ).users;
                        break;
                    }
                    case "selected": {
                        if (!this.selected.length) throw new Error("사용자를 선택해주세요");
                        users = this.selected;
                        break;
                    }
                }

                var { success } = await api.v1.message.post({
                    emails: users.map((user) => user.email),
                    subject: this.messageSubject,
                    message: this.message,
                });

                if (success) alert("발송되었습니다");
            } catch (error) {
                alert(error.message);
            }
        },

        upload(file, type) {
            if (!file) return;

            let reader = new FileReader();
            reader.onload = () => {
                var workSheets = [];
                var workBook = XLSX.read(reader.result, { type: "binary" });
                workBook.SheetNames.forEach((sheetName) => {
                    let sheet = XLSX.utils.sheet_to_json(workBook.Sheets[sheetName]);
                    workSheets.push(sheet);
                });
                this.$refs.uploader.excelSheet = workSheets[0]; // 첫번째 시트
                this.$refs.uploader.type = type;
                this.$refs.uploader.open();
            };
            reader.readAsBinaryString(file);
        },

        pushItem(user) {
            this.users = [user, ...this.users];
        },

        isOrganization(user) {
            return user.type == USER_TYPES.ORGANIZATION;
        },

        isSupporter(user) {
            return user.kind == "SUPPORTER";
        },
    },
    watch: {
        "filter.name"() {
            if (this.filter?.name?.length == 0) this.filter.name = null;
        },
        "filter.companyName"() {
            if (this.filter?.companyName?.length == 0) this.filter.companyName = null;
        },
        "filter.phone"() {
            if (this.filter?.phone?.length == 0) this.filter.phone = null;
        },
        "filter.type"() {
            if (this.filter.type !== USER_TYPES.ORGANIZATION && this.filter.kind) this.filter.kind = null;
        },
    },
    created() {
        this.init();
    },
};
</script>

<style lang="scss" scoped>
::v-deep .white-space-pre-line {
    white-space: pre-line;
}
</style>